<template>
  <div class="payOrderDetail">
    <el-card class="parent-info-card" shadow="hover">
      <div class="payOrderDetail-type-info">
        <div class="info-row">
          <el-button icon="el-icon-back" @click="$router.back()" >返回</el-button>
          <div class="title-container">
            <span class="info-label">商户单号：</span>
            <span class="info-value">{{ form.orderNo }}</span>
          </div>
          <div class="refund-btn-container">
            <el-button
              v-hasPermission="'order:edit'"
              type="danger" 
              v-if="hasPermission('order:edit') && form.payStatus === 1 && (form.refundStatus === 0)"
              @click="handleRefund"
            >
              申请退款
            </el-button>
          </div>
        </div>
      </div>
    </el-card>

    <el-row :gutter="20">
      <el-col :span="24">
        <!-- 1 订单基础信息 -->
        <el-card class="detail-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">订单基础信息</span>
          </div>
          <el-descriptions :column="2" border :label-style="{ width: '20%' }" :content-style="{ width: '30%' }">
            <el-descriptions-item label="所属组织">{{ form.orgName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="微信子商户号">{{ form.subMchId || '-' }}</el-descriptions-item>
            <el-descriptions-item label="设备IMEI">{{ form.imei || '-' }}</el-descriptions-item>
            <el-descriptions-item label="用户OpenID">{{ form.openid || '-' }}</el-descriptions-item>
            <el-descriptions-item label="下单时间">{{ formatTime(form.createTime) }}</el-descriptions-item>
            <el-descriptions-item label="用户手机号">{{ form.phone || '-' }}</el-descriptions-item>
            <el-descriptions-item label="最后更新时间">{{ formatTime(form.updateTime) }}</el-descriptions-item>
            <el-descriptions-item label=""></el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 2 套餐与金额信息 -->
        <el-card class="detail-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">支付内容信息</span>
          </div>
          <el-descriptions :column="2" border :label-style="{ width: '20%' }" :content-style="{ width: '30%' }">
            <el-descriptions-item label="支付金额">{{ formatAmount(form.amount) }} 元</el-descriptions-item>
            <el-descriptions-item label="下单时套餐名称">{{ form.productItemName }}</el-descriptions-item>
            <el-descriptions-item label="下单时售价">{{ formatAmount(form.productPrice) }} 元</el-descriptions-item>
            <el-descriptions-item label="下单时包含子弹数">{{ form.productBullets || '-' }} 发</el-descriptions-item>
            <el-descriptions-item label="下单时有效时长">{{ formatDuration(form.productDuration) || '-' }} 分</el-descriptions-item>
            <el-descriptions-item label="关联套餐ID">{{ form.productItemId || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-card>
 
        <!-- 3 支付与退款全链路 -->
        <el-card class="detail-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">支付与退款信息</span>
          </div>
          <el-descriptions :column="2" border :label-style="{ width: '20%' }" :content-style="{ width: '30%' }">
            <el-descriptions-item label="支付状态">
              <el-tag :type="payStatusMap[form.payStatus]?.type || 'info'" effect="light">{{ payStatusMap[form.payStatus]?.label || '未知状态' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="商户单号">{{ form.orderNo || '-' }}</el-descriptions-item>
            <el-descriptions-item label="支付时间">{{ formatTime(form.payTime) }}</el-descriptions-item>
            <el-descriptions-item label="微信支付交易号">{{ form.transactionId || '-' }}</el-descriptions-item>
            <el-descriptions-item label="退款状态">
              <el-tag :type="refundStatusMap[form.refundStatus]?.type || 'info'" effect="light">{{ refundStatusMap[form.refundStatus]?.label || '未退款' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="商户退款单号">{{ form.outRefundNo || '-' }}</el-descriptions-item>
            <el-descriptions-item label="退款时间">{{ formatTime(form.refundTime) }}</el-descriptions-item>
            <el-descriptions-item label="微信退款交易号">{{ form.refundId || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 4 设备指令关联 -->
        <el-card class="detail-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">设备指令关联信息</span>
          </div>
          <el-descriptions :column="2" border :label-style="{ width: '20%' }" :content-style="{ width: '30%' }">
            <el-descriptions-item label="指令发送状态">
              <el-tag :type="sendStatusMap[commandDetail.sendStatus]?.type || 'info'" effect="light" v-if="commandDetail.sendStatus">{{ sendStatusMap[commandDetail.sendStatus]?.label || '未知状态' }}</el-tag>
              <span v-else>-</span>
            </el-descriptions-item>
            <el-descriptions-item label="指令发送时间">{{ formatTime(commandDetail.sendTime) }}</el-descriptions-item>
            <el-descriptions-item label="关联设备指令ID">{{ commandDetail.id || '-' }}</el-descriptions-item>
            <el-descriptions-item label="设备确认时间">{{ formatTime(commandDetail.confirmTime) }}</el-descriptions-item>
          </el-descriptions>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import payOrderApi from '../../api/payOrder';
import { hasPermission } from '../../utils/hasPermission';

export default {
  name: 'PayOrderDetail',
  data() {
    return {
      // 订单详情主数据
      form: {
        orderNo: '',
        subMchId: '',
        orgName: '',
        imei: '',
        openid: '',
        phone: '',
        productItemId: null,
        productItemName: '',
        productPrice: 0,
        productBullets: null,
        productDuration: null,
        amount: 0,
        payStatus: 0,
        transactionId: '',
        payTime: null,
        refundStatus: 0,
        outRefundNo: '',
        refundId: '',
        refundTime: null,
        commandId: null,
        sendStatus: null,
        sendTime: null,
        confirmTime: null,
        createTime: null,
        updateTime: null
      },
      // 关联的设备指令详情
      commandDetail: {
        id: null,
        sendStatus: null,
        sendTime: null,
        confirmTime: null
      },
      // 状态映射配置
      payStatusMap: {
        0: { label: '未支付', type: 'warning' },
        1: { label: '已支付', type: 'success' },
        2: { label: '已关闭', type: 'info' },
        3: { label: '已退款', type: 'danger' }
      },
      refundStatusMap: {
        0: { label: '未退款', type: 'info' },
        1: { label: '退款中', type: 'warning' },
        2: { label: '退款成功', type: 'success' }
      },
      sendStatusMap: {
        0: { label: '未发送', type: 'info' },
        1: { label: '已发送', type: 'warning' },
        2: { label: '已确认', type: 'success' },
        3: { label: '发送失败（超过最大重发次数，不再重试）', type: 'danger' }
      }
    };
  },
  created() {
    // 页面加载时获取订单ID，调用详情接口
    const orderNo = this.$route.query.orderNo;
    if (orderNo) {
      this.getOrderDetail(orderNo);
      this.form.orderNo = orderNo;
    } else {
      this.$message.error('商户单号不能为空');
    }
  },
  methods: {
    // 获取订单详情
    getOrderDetail(orderNo) {
      payOrderApi.getDetailByOrderNo(orderNo).then(response => {
        if (response.success) {
          this.form = response.data || {}
          this.commandDetail = response.data.commandDetail || {}
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载订单详情失败：' + error.message)
      })
    },
    // 时间格式化
    formatTime(time) {
      if (!time) return '-';
      return this.$options.filters.formatTime(time);
    },
    // 金额格式化：分转元，保留2位小数
    formatAmount(amount) {
      if (amount === null || amount === undefined) return '0.00';
      return (amount / 100).toFixed(2);
    },
    // 时间格式化：秒转分
    formatDuration(duration) {
      if (duration === null || duration === undefined) return '00:00';
      return Math.floor(duration / 60) + ':' + (duration % 60).toString().padStart(2, '0');
    },
    hasPermission(permCode) {
      return hasPermission(permCode);
    },
    // 申请退款
    handleRefund() {
      if (!hasPermission('order:edit')) {
        this.$message.error('无退款权限');
        return;
      }
      this.$confirm(`确定要对该订单申请退款吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 组装请求参数
        const params = {
          orderNo: this.form.orderNo, // 商户单号
          refundFee: this.form.amount, // 退款金额
          totalFee: this.form.amount // 订单金额
        };
        payOrderApi.refund(params).then(response => {
          if (response.success) {
            this.$message.success(response.message || '操作成功')
            this.getOrderDetail(this.form.orderNo)
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          this.$message.error('操作失败：' + error.message)
        })
      }).catch(() => {
        // 取消操作（此处可留空，仅用于捕获异常）
      });
    }
  }
};
</script>

<style scoped>
.parent-info-card {
  width: 100%;
  margin-bottom: 20px;
  border-left: 3px solid #409EFF;
  /* 保持标识性边框 */
  box-sizing: border-box;
  padding: 0 10px;
}
.payOrderDetail-type-info {
  font-size: 4vh;
  font-weight: bold;
}
.info-row {
  display: flex;
  align-items: center; /* 上下居中 */
  width: 100%;
}
.title-container {
  flex: 1;
  text-align: center;
}
.refund-btn-container {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 180px;
  justify-content: flex-end;
}
.detail-card {
  margin-bottom: 20px;
}
.card-header {
  display: flex;
  align-items: center;
}
.card-title {
  font-size: 16px;
  font-weight: 500;
}
</style>